module.exports = __webpack_public_path__ + "6b1a4b0a7fd8167925172176775c84e9.woff";